import axios from "axios";
import { CONFIG } from "../../config";

export const getCoverBanner = async () => {
  const result = await axios.get(`${CONFIG.API_URL}/new-iframe/customer/coverBanner`);
  return result?.data?.data;
};
